import { z } from "zod";

/**
 * Room Schema - ห้องเรียน
 */
export const RoomSchema = z.object({
  id: z.string(),
  name: z.string(),
  capacity: z.number().int().nullable(),
  description: z.string().nullable(),
  status: z.enum(["active", "inactive", "maintenance"]),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type RoomDTO = z.infer<typeof RoomSchema>;

/**
 * Create Room Schema
 */
export const CreateRoomSchema = z.object({
  name: z.string().min(1, "ຊື່ຕ້ອງບໍ່ວ່າງ"),
  capacity: z.number().int().positive().nullable().optional(),
  description: z.string().nullable().optional(),
  status: z.enum(["active", "inactive", "maintenance"]).default("active"),
});
export type CreateRoomDTO = z.infer<typeof CreateRoomSchema>;

/**
 * Update Room Schema
 */
export const UpdateRoomSchema = z.object({
  name: z.string().min(1, "ຊື່ຕ້ອງບໍ່ວ່າງ").optional(),
  capacity: z.number().int().positive().nullable().optional(),
  description: z.string().nullable().optional(),
  status: z.enum(["active", "inactive", "maintenance"]).optional(),
});
export type UpdateRoomDTO = z.infer<typeof UpdateRoomSchema>;
